var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cosmetic-allergies-template',{attrs:{"cosmetic-allergies":_vm.cosmeticAllergies},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }